import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "logo-and-title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["aria-expanded"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "brand-link",
        "aria-label": "Attractive Salon and Academy — Home"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.logo,
            alt: "Attractive Unisex Salon and Academy logo",
            class: "logo"
          }, null, 8, _hoisted_3),
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "salon-title" }, "Attractive Salon and Academy", -1))
        ]),
        _: 1,
        __: [2]
      })
    ]),
    _createElementVNode("button", {
      class: "mobile-nav-toggle",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNav && _ctx.toggleMobileNav(...args))),
      "aria-label": "Toggle navigation",
      "aria-expanded": _ctx.isMobileNavOpen
    }, _cache[3] || (_cache[3] = [
      _createElementVNode("span", { class: "hamburger-icon" }, null, -1)
    ]), 8, _hoisted_4),
    _createElementVNode("nav", {
      class: _normalizeClass(["main-nav", { 'mobile-nav-open': _ctx.isMobileNavOpen }])
    }, [
      _createVNode(_component_router_link, {
        to: "/",
        onClick: _ctx.closeMobileNav
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("Home")
        ])),
        _: 1,
        __: [4]
      }, 8, ["onClick"]),
      _createVNode(_component_router_link, {
        to: "/about",
        onClick: _ctx.closeMobileNav
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("About")
        ])),
        _: 1,
        __: [5]
      }, 8, ["onClick"]),
      _createVNode(_component_router_link, {
        to: "/services",
        onClick: _ctx.closeMobileNav
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("Service")
        ])),
        _: 1,
        __: [6]
      }, 8, ["onClick"]),
      (_ctx.isUserLoggedIn && _ctx.canAccessAdmin)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/admin",
            onClick: _ctx.closeMobileNav
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode(" Admin ")
            ])),
            _: 1,
            __: [7]
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.isUserLoggedIn)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: "#",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogoutAndCloseNav && _ctx.handleLogoutAndCloseNav(...args)), ["prevent"])),
            class: "nav-link logout-link"
          }, " Logout "))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: "/login",
            onClick: _ctx.closeMobileNav
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("Login")
            ])),
            _: 1,
            __: [8]
          }, 8, ["onClick"]))
    ], 2)
  ]))
}